import { DTO_MusicCollection } from './music-collection';
import { DTO_ChangeableParameter } from './changeableParameter';

export class DTO_Context extends DTO_MusicCollection {
    changeableParameter: DTO_ChangeableParameter[];
    defaultChangeableParameter: DTO_ChangeableParameter[];
}